module.exports = __webpack_public_path__ + "img/clutch-b2b-logo.cffab4e2.svg";